import axios from "axios";
import Cookie from "js-cookie";

async function connection(
  url,
  data = { fields: "", tbl_name: "", conditions: "" }
) {
  let formData = new FormData();
  formData.append("usertoken", Cookie.get("token"));
  Object.keys(data).forEach((value) => {
    formData.append(value, data[value]);
  });
  return await axios
    .post(`http://mvc.dade24.ir/api/${url}`, formData)
    .then((res) => {
      // console.log(url, res.data);
      return res.data;
    });
}

async function updateRecord(
  tableName,
  data = { keyvalues: {}, conditions: "" }
) {
  data.keyvalues = Object.keys(data.keyvalues).reduce((total, value, index) => {
    if (index != 0) {
      return (total += "@@" + value + "," + data.keyvalues[value]);
    }
    return (total += value + "," + data.keyvalues[value]);
  }, "");
  return await connection(`Update_${tableName}`, data);
}

async function insertRecord(tableName, data = {}) {
  if (!Object.keys(data).includes("mtm")) {
    let date = new Date();
    data.mtm = Math.floor(date.getTime() / 1000);
  }
  return await connection(`Insert_${tableName}`, data);
}

async function findRecord(
  tableName,
  data = { fields: "", tbl_name: "", conditions: "" }
) {
  return await connection(`Find_${tableName}`, data);
}

async function deleteRecord(tableName, conditions) {
  return await connection(`Delete_${tableName}`, { conditions });
}

async function transferMoney(
  fromWalletId,
  toWalletId,
  type,
  price,
  factor_id = 0,
  mtm = 0
) {
  if (mtm == 0) {
    mtm = new Date();
    mtm = Math.floor(mtm.getTime() / 1000);
  }
  let res = await insertRecord("wallets_transactions", {
    type: type,
    transaction_type: 0,
    amount: price,
    from_wallet_id: fromWalletId,
    to_wallet_id: toWalletId,
    factor_id,
    mtm,
  });
  if (!res.status) return false;
  let result = res.result.id;
  res = updateWalletsForTransfer(fromWalletId, toWalletId, price);
  return res ? result : false;
}

async function updateWalletsForTransfer(fromWalletId, toWalletId, price) {
  price = parseInt(price);
  let mtm = new Date();
  mtm = Math.floor(mtm.getTime() / 1000);
  let fromWallet, toWallet;
  {
    let x = await findRecord("wallets", {
      fields: "id, current_inventory",
      conditions: `id/in/${fromWalletId},${toWalletId}`,
    });
    let temp = x.find((value) => value.id == fromWalletId);
    fromWallet = {
      id: temp.id,
      current_inventory: parseInt(temp.current_inventory),
    };
    temp = x.find((value) => value.id == toWalletId);
    toWallet = {
      id: temp.id,
      current_inventory: parseInt(temp.current_inventory),
    };
  }

  let res = await updateRecord("wallets", {
    keyvalues: {
      current_inventory: fromWallet.current_inventory - price,
      uptmtm: mtm,
    },
    conditions: `id/=/${fromWallet.id}`,
  });
  if (!Boolean(res.status)) return false;

  res = await updateRecord("wallets", {
    keyvalues: {
      current_inventory: toWallet.current_inventory + price,
      uptmtm: mtm,
    },
    conditions: `id/=/${toWallet.id}`,
  });
  return Boolean(res.status);
}

function sortArray(data, key) {
  let res = [...data];
  res.sort((a, b) => {
    if (a[key] == b[key]) return 0;
    if (isNaN(a[key])) return 1;
    if (isNaN(b[key])) return -1;
    return parseInt(b[key]) - parseInt(a[key]);
  });
  return res;
}

export {
  connection,
  updateRecord,
  insertRecord,
  findRecord,
  deleteRecord,
  transferMoney,
  updateWalletsForTransfer,
  sortArray,
};
